import React, { forwardRef, useEffect, useState } from "react";

import { Close } from "icons";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";

import { Button, Typography } from "clearsense-ui/components";

const PredictionResult = forwardRef(({ prediction, setPrediction }, ref) => {
  const initialPredictionStyles = () =>
    prediction > 0.5
      ? {
          progressColor: "#bd271e",
          progressRisk: "High Risk",
          progressResult: "CKD Detected",
        }
      : {
          progressColor: "#017d73",
          progressRisk: "Low Risk",
          progressResult: "CKD Not Detected",
        };

  const [predictionStyles, setPredictionStyles] = useState(
    initialPredictionStyles
  );

  useEffect(() => {
    setPredictionStyles(initialPredictionStyles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prediction]);

  return (
    <div className="cs-rdd-result-wrapper" ref={ref}>
      <div className="cs-rdd-result-wrapper__title">
        <Typography style="h3" type="semibold" className="text-gray-600">
          Predicted Information
        </Typography>
        <Button
          style="text"
          className="cursor-pointer"
          icon={() => <Close size={22} />}
          onClick={() => setPrediction()}
        />
      </div>
      <div className="flex flex-col items-start justify-center p-2 w-60">
        <CircularProgressbarWithChildren
          value={Math.round(prediction * 100)}
          text={`${Math.round(prediction * 100)}%`}
          circleRatio={0.75}
          strokeWidth={5}
          styles={buildStyles({
            rotation: 1 / 2 + 1 / 8,
            strokeLinecap: "butt",
            textColor: "#343741",
            pathColor: predictionStyles.progressColor,
          })}
        >
          <Typography style="h3" type="semibold" className="mt-24">
            {predictionStyles.progressRisk}
          </Typography>
        </CircularProgressbarWithChildren>
        <div className="flex justify-center w-full">
          <Typography style="h3" type="semibold" className="text-gray-600">
            {predictionStyles.progressResult}
          </Typography>
        </div>
      </div>
    </div>
  );
});

PredictionResult.displayName = "Prediction Result";

export default PredictionResult;
